import NewLayout from "@components/new-ui/Layout";
import TemplateHeader from "@components/free-whatsapp-message-templates/TemplateHeader";
import TemplateNavigator from "@components/free-whatsapp-message-templates/TemplateNavigator";
import React from "react";
import { GetServerSideProps, GetServerSidePropsResult } from "next";
import { getJSON } from "@utils/fetch";
export interface UseCase {
    template_link: string;
    use_case: string;
    industry: string;
    created_by: string | null;
    created_at: string;
    updated_by: string | null;
    updated_at: string;
    is_deleted: boolean;
    is_active: boolean;
    id: number;
}

interface WhatsAppTemplatesProps {
    useCases: UseCase[];
}
const WhatsAppTemplates: React.FC<WhatsAppTemplatesProps> = ({ useCases }) => {
    return (
        <NewLayout
            title="Free high-converting templates for WhatsApp Business conversations"
            description="Looking for some ready reference WhatsApp messages for different business scenarios? Find messaging ideas for your sales, marketing, support, updates, and more in one place."
            canonical="https://gallabox.com/resources/free-whatsapp-message-templates"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/programmatic_seo/og-images/og.png" }}
            keywords="WhatsApp Chat button, WhatsApp Chat Widget, How to create chat widget for free"
        >
            <TemplateHeader
                chipTitle="WhatsApp message templates"
                mainTitle="Free high-converting templates for WhatsApp Business conversations"
                description="Looking for some ready reference WhatsApp messages for different business scenarios? Find messaging ideas for your sales, marketing, support, updates, and more in one place."
                simpleText="Turn connections to conversations."
                buttonText="Claim your 7-day free trial!"
                variantColor="linear-gradient(180deg, #E5F3FF 0%, #FFF 100%)"
                chipBg="#CCE6FF"
                chipBorder="#99CEFF"
                chipTextColor="#003566"
                imageLink="https://assets.gallabox.com/gb-home/programmatic_seo/header-images/header.png"
            />
            <TemplateNavigator useCases={useCases} />
            <div
                className="flex flex-col items-center gap-7 py-10"
                style={{
                    background: "linear-gradient(0deg, rgba(210, 233, 255, 0.80) 0%, rgba(210, 233, 255, 0.80) 100%)",
                }}
            >
                <style jsx>{`
                    @media (min-width: 1024px) {
                        /* This is the breakpoint for laptops (lg) */
                        div {
                            background: linear-gradient(92deg, rgba(210, 233, 255, 0.8) 0%, rgba(255, 241, 214, 0.8) 50.5%, rgba(214, 208, 255, 0.8) 100%) !important;
                        }
                    }
                `}</style>
                <p className="text-4xl font-semibold text-gray-700 text-center mx-5 mx-auto lg:max-w-6xl w-full ">
                    Bring life to your WhatsApp chats with automations that engage, convert and boost your revenue.
                </p>
                <a
                    href="https://app.gallabox.com/signup"
                    target="_blank"
                    rel="noreferrer"
                    className="px-4 py-2 lg:px-8 text-white font-bold rounded-md hover:no-underline focus:outline-none hover:shadow-lg bg-blue-500 hover:bg-blue-600 transition duration-300 ease-in-out w-fit cursor-pointer"
                >
                    Get your 7-day free trial here
                </a>
            </div>
        </NewLayout>
    );
};

export const getServerSideProps: GetServerSideProps = async (): Promise<GetServerSidePropsResult<{ useCases: UseCase[] }>> => {
    let useCases: UseCase[] | null = null;
    try {
        useCases = await getJSON("/rest/v1/use_cases");
    } catch (err) {
        console.error("Error fetching use cases:", err);
    }
    return {
        props: {
            useCases: useCases || [], // Ensure we return an empty array if null
        },
    };
};

export default WhatsAppTemplates;
